import React, { useState } from "react";
import SurveyDetail from "./SurveyDetail";
import { Modal } from "react-bootstrap";
import ConfirmeDialog from "components/Dialogs/ConfirmeDialog";
import { createRef } from "react";
import { useSurveyContext } from "context/SurveyContext";

function SolveSurveyModal({ show, onHide, selectedSurvey, preloadedTags }) {
  const [isClose, setIsClose] = useState(false);
  const ref = createRef();
  const { isRequired, canRemindLater } = useSurveyContext();

  const canCloseModal = !isRequired || (isRequired && canRemindLater);

  const handleClose = () => {
    if (!canCloseModal) {
      return;
    }
    setIsClose(true);
  };

  const handleSubmit = () => {
    if (ref?.current && typeof ref?.current?.submit === "function") {
      ref?.current?.submit();
    }
  };

  return (
    <Modal
      show={show}
      onHide={canCloseModal ? handleClose : null}
      backdrop={canCloseModal ? true : "static"}
      keyboard={canCloseModal}
      size="xl"
    >
      <SurveyDetail
        ref={ref}
        survey={selectedSurvey}
        onHide={onHide}
        preloadedTags={preloadedTags}
      />

      {isRequired && !canRemindLater && (
        <div className="alert alert-danger mx-3 mt-2">
          <strong>Dikkat!</strong> Bu anketi tamamlamanız gerekmektedir. Anketi tamamlamadan sistemi
          kullanmaya devam edemezsiniz.
        </div>
      )}

      <div className="d-flex justify-content-center py-4">
        <button className="btn lms-btn-primary mr-2" onClick={handleSubmit}>
          Anketi Tamamla
        </button>
        {canCloseModal && (
          <button onClick={handleClose} className="btn btn-secondary">
            Kaydetmeden Çık
          </button>
        )}
      </div>

      {isClose && (
        <ConfirmeDialog
          show={isClose}
          submit={onHide}
          onHide={() => setIsClose(false)}
          modalTitle="Kaydetmeden Çık"
          modalMessage="Anketi bitirmeden çıkmak istedğine emin misin? Yaptığın işlemler kaydedilmeyecektir."
        />
      )}
    </Modal>
  );
}

export default SolveSurveyModal;
